import React from 'react';
import { useNavigate } from 'react-router-dom';

const Contact: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="px-4 py-16 lg:py-24 bg-white">
      <div className="max-w-sm lg:max-w-7xl mx-auto">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl lg:text-5xl font-bold text-gray-900 mb-4">Contactez-nous</h2>
          <p className="text-base lg:text-lg text-gray-600">Nous sommes là pour vous 24h/24 et 7j/7</p>
        </div>

        {/* Quick Contact Buttons - Horizontal on Desktop */}
        <div className="grid grid-cols-2 lg:flex lg:justify-center gap-4 lg:gap-6 mb-12 lg:mb-16">
          <a
            href="tel:+33632410246"
            className="bg-gradient-to-br from-red-600 to-red-700 rounded-2xl p-5 lg:px-12 lg:py-8 text-white text-center shadow-xl hover:shadow-2xl transition-all cursor-pointer"
          >
            <i className="ri-phone-line text-3xl lg:text-5xl mb-2"></i>
            <p className="text-xs lg:text-base font-bold whitespace-nowrap">Appelez-nous</p>
            <p className="text-xs lg:text-sm opacity-80">24/7</p>
          </a>
          <a
            href="mailto:contact@speedtransport.fr"
            className="bg-gradient-to-br from-yellow-500 to-orange-500 rounded-2xl p-5 lg:px-12 lg:py-8 text-white text-center shadow-xl hover:shadow-2xl transition-all cursor-pointer"
          >
            <i className="ri-mail-line text-3xl lg:text-5xl mb-2"></i>
            <p className="text-xs lg:text-base font-bold whitespace-nowrap">Email</p>
            <p className="text-xs lg:text-sm opacity-80">Réponse rapide</p>
          </a>
          <button
            onClick={() => navigate('/laisser-un-avis')}
            className="bg-gradient-to-br from-green-600 to-green-700 rounded-2xl p-5 lg:px-12 lg:py-8 text-white text-center shadow-xl hover:shadow-2xl transition-all cursor-pointer"
          >
            <i className="ri-star-line text-3xl lg:text-5xl mb-2"></i>
            <p className="text-xs lg:text-base font-bold whitespace-nowrap">Laisser un avis</p>
            <p className="text-xs lg:text-sm opacity-80">Sur Google</p>
          </button>
        </div>

        {/* Info Cards - 3 Columns on Desktop */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-8">
          <div className="bg-gray-50 rounded-2xl p-5 lg:p-8 flex items-center lg:flex-col lg:text-center hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 lg:w-20 lg:h-20 bg-red-100 rounded-xl flex items-center justify-center mr-4 lg:mr-0 lg:mb-6">
              <i className="ri-map-pin-line text-2xl lg:text-4xl text-red-600"></i>
            </div>
            <div>
              <p className="text-xs lg:text-sm text-gray-500 font-semibold mb-1">Adresse</p>
              <p className="text-sm lg:text-lg font-bold text-gray-900">Paris et Île-de-France</p>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-5 lg:p-8 flex items-center lg:flex-col lg:text-center hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 lg:w-20 lg:h-20 bg-yellow-100 rounded-xl flex items-center justify-center mr-4 lg:mr-0 lg:mb-6">
              <i className="ri-time-line text-2xl lg:text-4xl text-yellow-600"></i>
            </div>
            <div>
              <p className="text-xs lg:text-sm text-gray-500 font-semibold mb-1">Horaires</p>
              <p className="text-sm lg:text-lg font-bold text-gray-900">24h/24 - 7j/7</p>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-5 lg:p-8 flex items-center lg:flex-col lg:text-center hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 lg:w-20 lg:h-20 bg-green-100 rounded-xl flex items-center justify-center mr-4 lg:mr-0 lg:mb-6">
              <i className="ri-customer-service-line text-2xl lg:text-4xl text-green-600"></i>
            </div>
            <div>
              <p className="text-xs lg:text-sm text-gray-500 font-semibold mb-1">Support</p>
              <p className="text-sm lg:text-lg font-bold text-gray-900">Assistance immédiate</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;